import { PAGINATION_CONSTANTS } from '../../constants'
import { ComponentSettingKey } from '../../types/setting-keys'
import {
  getDefaultLineOverlay,
  getDefaultMargin,
  getDefaultMarginOverlay,
  getDefaultTypography,
  getDefaultWidthOverlay,
} from '../utils'

export const ListDesignSettings = {
  // width
  'list-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'list-design-image-width': {
    phone: [56],
    'phone-landscape': [56],
    tablet: [56],
    'tablet-landscape': [56],
    desktop: [56],
    tv: [56],
  },
  'list-design-search-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
  },

  // alignment
  'list-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'list-design-comp-title-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'list-design-group-header-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'list-design-group-search-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },

  'list-design-pagination-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // aspect ratio
  'list-design-media-ratio': {
    phone: '1:1',
    'phone-landscape': '1:1',
    tablet: '1:1',
    'tablet-landscape': '1:1',
    desktop: '1:1',
    tv: '1:1',
  },

  // media icon
  // 'list-design-icon-variant': {
  //   phone: 'filled',
  //   'phone-landscape': 'filled',
  //   tablet: 'filled',
  //   'tablet-landscape': 'filled',
  //   desktop: 'filled',
  //   tv: 'filled',
  // },
  // 'list-design-icon-background-color-variant': {
  //   dark: 'primary-80',
  //   light: 'primary-80',
  // },
  // 'list-design-icon-color-variant': {
  //   dark: 'primary-20',
  //   light: 'primary-20',
  // },
  // 'list-design-icon-color-filled': {
  //   phone: false,
  //   'phone-landscape': false,
  //   tablet: false,
  //   'tablet-landscape': false,
  //   desktop: false,
  //   tv: false,
  // },
  // 'list-design-icon-weight': {
  //   phone: [200],
  //   'phone-landscape': [200],
  //   tablet: [200],
  //   'tablet-landscape': [200],
  //   desktop: [200],
  //   tv: [200],
  // },
  // 'list-design-icon-color-custom': {
  //   phone: false,
  //   'phone-landscape': false,
  //   tablet: false,
  //   'tablet-landscape': false,
  //   desktop: false,
  //   tv: false,
  // },
  // 'list-design-icon-color-column': {
  //   phone: 'col',
  //   'phone-landscape': 'col',
  //   tablet: 'col',
  //   'tablet-landscape': 'col',
  //   desktop: 'col',
  //   tv: 'col',
  // },
  // 'list-design-icon-size': {
  //   phone: [24],
  //   'phone-landscape': [24],
  //   tablet: [24],
  //   'tablet-landscape': [24],
  //   desktop: [24],
  //   tv: [24],
  // },
  // 'list-design-icon-grade': {
  //   phone: 0,
  //   'phone-landscape': 0,
  //   tablet: 0,
  //   'tablet-landscape': 0,
  //   desktop: 0,
  //   tv: 0,
  // },

  // multiline
  'list-design-multiline': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },

  // Orientation
  'list-design-orientation': {
    phone: 'vertical',
    'phone-landscape': 'vertical',
    tablet: 'vertical',
    'tablet-landscape': 'vertical',
    desktop: 'vertical',
    tv: 'vertical',
  },

  // Layout
  'list-data-num-items': {
    phone: 100,
    'phone-landscape': 100,
    tablet: 100,
    'tablet-landscape': 100,
    desktop: 100,
    tv: 100,
  },
  'list-design-num-cols': {
    phone: 1,
    'phone-landscape': 1,
    tablet: 1,
    'tablet-landscape': 1,
    desktop: 1,
    tv: 1,
  },
  'list-design-column-row': {
    phone: 'column',
    'phone-landscape': 'column',
    tablet: 'column',
    'tablet-landscape': 'column',
    desktop: 'column',
    tv: 'column',
  },
  'list-design-pagination': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },
  'list-design-num-rows': {
    phone: 24,
    'phone-landscape': 24,
    tablet: 24,
    'tablet-landscape': 24,
    desktop: 24,
    tv: 24,
  },

  'list-default-per-page': {
    phone: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    'phone-landscape': PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    tablet: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    'tablet-landscape': PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    desktop: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    tv: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
  },
  // (nested) typography
  'list-design-typography': {
    'list-design-label-typography': {
      phone: getDefaultTypography('Label Medium'),
      'phone-landscape': getDefaultTypography('Label Medium'),
      tablet: getDefaultTypography('Label Medium'),
      'tablet-landscape': getDefaultTypography('Label Medium'),
      desktop: getDefaultTypography('Label Medium'),
      tv: getDefaultTypography('Label Medium'),
    },
    'list-design-supporting-text-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'list-design-text-3-typography': {
      phone: getDefaultTypography('Label Small'),
      'phone-landscape': getDefaultTypography('Label Small'),
      tablet: getDefaultTypography('Label Small'),
      'tablet-landscape': getDefaultTypography('Label Small'),
      desktop: getDefaultTypography('Label Small'),
      tv: getDefaultTypography('Label Small'),
    },
    'list-design-metadata-typography': {
      phone: getDefaultTypography('Label Small'),
      'phone-landscape': getDefaultTypography('Label Small'),
      tablet: getDefaultTypography('Label Small'),
      'tablet-landscape': getDefaultTypography('Label Small'),
      desktop: getDefaultTypography('Label Small'),
      tv: getDefaultTypography('Label Small'),
    },
    'list-design-headline-typography': {
      phone: getDefaultTypography('Label Large'),
      'phone-landscape': getDefaultTypography('Label Large'),
      tablet: getDefaultTypography('Label Large'),
      'tablet-landscape': getDefaultTypography('Label Large'),
      desktop: getDefaultTypography('Label Large'),
      tv: getDefaultTypography('Label Large'),
    },
    'list-design-group-header-typography': {
      phone: getDefaultTypography('Display Extra Small'),
      'phone-landscape': getDefaultTypography('Display Extra Small'),
      tablet: getDefaultTypography('Display Extra Small'),
      'tablet-landscape': getDefaultTypography('Display Extra Small'),
      desktop: getDefaultTypography('Display Extra Small'),
      tv: getDefaultTypography('Display Extra Small'),
    },
  },

  // Spacing
  'list-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'list-design-column-margin': {
    phone: getDefaultMargin([0]),
    'phone-landscape': getDefaultMargin([0]),
    tablet: getDefaultMargin([0]),
    'tablet-landscape': getDefaultMargin([0]),
    desktop: getDefaultMargin([0]),
    tv: getDefaultMargin([0]),
  },
  'list-design-item-margin': {
    phone: getDefaultMargin([5, 0]),
    'phone-landscape': getDefaultMargin([5, 0]),
    tablet: getDefaultMargin([0, 15, 15, 0]),
    'tablet-landscape': getDefaultMargin([5, 0]),
    desktop: getDefaultMargin([5, 0]),
    tv: getDefaultMargin([5, 0]),
  },
  'list-design-item-padding': {
    phone: getDefaultMargin([10]),
    'phone-landscape': getDefaultMargin([10]),
    tablet: getDefaultMargin([10]),
    'tablet-landscape': getDefaultMargin([10]),
    desktop: getDefaultMargin([10]),
    tv: getDefaultMargin([10]),
  },
  'list-design-headline-margin': {
    phone: getDefaultMargin([10, 0]),
    'phone-landscape': getDefaultMargin([10, 0]),
    tablet: getDefaultMargin([10, 0]),
    'tablet-landscape': getDefaultMargin([10, 0]),
    desktop: getDefaultMargin([10, 0]),
    tv: getDefaultMargin([10, 0]),
  },
  'list-design-group-header-margin': {
    phone: getDefaultMargin([20, 0]),
    'phone-landscape': getDefaultMargin([20, 0]),
    tablet: getDefaultMargin([20, 0]),
    'tablet-landscape': getDefaultMargin([20, 0]),
    desktop: getDefaultMargin([20, 0]),
    tv: getDefaultMargin([20, 0]),
  },
  'list-design-search-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },
  'list-design-filter-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },

  'list-design-item-gap': {
    phone: { value: 5, unit: 'px' },
    'phone-landscape': { value: 5, unit: 'px' },
    tablet: { value: 5, unit: 'px' },
    'tablet-landscape': { value: 5, unit: 'px' },
    desktop: { value: 5, unit: 'px' },
    tv: { value: 5, unit: 'px' },
  },

  'list-design-same-height': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },
  'list-design-hover-effect': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },

  // lines
  'list-design-title-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'list-design-supporting-text-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'list-design-text-3-lines': {
    phone: [1],
    'phone-landscape': [1],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [3],
    tv: [3],
    overflowSetting: getDefaultLineOverlay,
  },
  'list-design-title-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'list-design-title-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'list-design-title-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'list-design-title-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-title-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'list-design-supporting-text-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'list-design-supporting-text-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'list-design-supporting-text-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'list-design-supporting-text-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-supporting-text-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'list-design-comp-title-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'list-design-comp-title-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'list-design-comp-title-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'list-design-comp-title-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-group-header-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'list-design-group-header-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'list-design-group-header-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'list-design-group-header-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'list-design-group-header-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-color-mode': {
    dark: 'static',
    light: 'static',
  },
  'list-design-color-tone-order': {
    dark: 'asc',
    light: 'asc',
  },
  'list-design-color-start-palette': {
    dark: 'primary',
    light: 'primary',
  },
  'list-design-color-end-palette': {
    dark: 'primary',
    light: 'primary',
  },
  'list-design-item-bg-color': {
    dark: 'primary-100',
    light: 'primary-100',
  },
  'list-design-item-bg-opacity': {
    dark: 100,
    light: 100,
  },
  'list-design-metadata-bg-color': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-badge-color': {
    dark: 'primary-20',
    light: 'primary-20',
  },
  'list-design-text-3-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'list-design-text-3-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'list-design-text-3-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'list-design-text-3-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-text-3-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'list-design-rating-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'list-design-rating-color-solid': {
    dark: 'primary-5',
    light: 'primary-5',
  },
  'list-design-rating-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'list-design-rating-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-rating-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'list-design-search-bg-color': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'list-design-filter-chip-color': {
    dark: 'primary-95',
    light: 'primary-95',
  },
  'list-design-filter-bg-color': {
    dark: 'primary-95',
    light: 'primary-95',
  },
  'list-design-add-button-color': {
    dark: 'primary-20',
    light: 'primary-20',
  },
}
